import { Checkbox, CheckboxProps } from '@mui/material';
import { styled } from '@mui/material/styles';

interface StyledCheckboxProps extends CheckboxProps {
  customcolor?: string;
}

const CheckboxComponent = styled((props: StyledCheckboxProps) => (
  <Checkbox {...props} />
))(({ customcolor }) => ({
  color: customcolor || 'var(--primary)',
  '&.Mui-checked': {
    color: customcolor || 'var(--primary)',
  },
  '&.MuiCheckbox-indeterminate': {
    color: customcolor || 'var(--primary)',
  },
  '& .MuiSvgIcon-root': {
    borderRadius: 6,
  },
}));

export default CheckboxComponent;
